<template lang="html">
  <div>

    <md-layout md-gutter="16" md-align="center" md-flex="100">
      <md-card style="padding:30px; padding-top:0; width:100%">
        <md-card-header>
          <md-layout md-align="center">
            <h1>
              Pagina Inhabilitada
            </h1>
          </md-layout>
        </md-card-header>
        <md-layout md-align="center">
          <h2>Su licencia de STSHOP ha vencido... favor de comunicarse con COMPART</h2>
        </md-layout>
      </md-card>
      
    </md-layout>
  </div>
</template>

<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';

export default {
  name: 'Licencia',
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      pedidos: [],
    };
  },
  computed: {
  },
  components: {},
  methods: {
    
    goToInfo() {
      this.$router.push({ name: 'perfil' });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.cartItems {
  .md-list-item-container{
    padding-bottom: 10px;
  }
}

.cartImage {
  max-height: 90px;
}
.cartDetails{
  margin-right:5px;
}
.cartTotal{
  font-size:20px;
  opacity: .8;
  margin-left: 5px;
}
.prices {
  text-align: right;
  padding-right: 10px;
  font-size: 20px;
}

.totalLabel{
  font-size: 30px;
  opacity: .7;
  margin-right:5px;
}

.totalData{
  font-size: 30px;
  font-weight: bold;
  opacity: .7;
}

.totales{
  padding:10px;
  text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/spa/licencia/licencia.vue